import React from 'react';
import {
  IconAlertTriangle,
  IconCheck,
  IconCircleCheck,
  IconCircleDashed,
  IconMinus,
  IconX,
} from '@tabler/icons-react';
import { DesignModelDto } from 'src/api/FiretrolApiClient';
import { Group } from 'src/design/atoms/Group';
import { Loader } from 'src/design/atoms/Loader';
import { Text } from 'src/design/atoms/Text';
import { Tooltip } from 'src/design/atoms/Tooltip';
import {
  FILE_KINDS,
  FILE_KIND_LABELS,
} from 'src/routes/Jobs/DesignModels/designModelFiles';
import {
  DesignModelListStatus,
  getDesignModelListStatus,
  listStatusTooltip,
  presentFileKinds,
} from 'src/routes/Jobs/DesignModels/designModelStatus';

const STATUS_ICONS: Record<DesignModelListStatus, React.ReactNode> = {
  Ready: <IconCircleCheck size={16} color="var(--mantine-color-green-7)" />,
  Processing: <Loader size={14} color="blue" />,
  Failed: <IconX size={16} color="var(--mantine-color-red-7)" />,
  Incomplete: (
    <IconAlertTriangle size={16} color="var(--mantine-color-orange-7)" />
  ),
  'Not processed': (
    <IconCircleDashed size={16} color="var(--mantine-color-gray-6)" />
  ),
};

export const DesignModelStatusCell: React.FC<{ model: DesignModelDto }> = ({
  model,
}) => {
  const status = getDesignModelListStatus(model);
  const tooltip = listStatusTooltip(model);
  return (
    <Tooltip label={tooltip} disabled={!tooltip} multiline maw={300}>
      <Group gap={6} wrap="nowrap">
        {STATUS_ICONS[status]}
        <Text size="sm" c="bright">
          {status}
        </Text>
      </Group>
    </Tooltip>
  );
};

export const DesignModelFilesCell: React.FC<{ model: DesignModelDto }> = ({
  model,
}) => {
  const present = presentFileKinds(model);
  return (
    <Group gap="sm" wrap="nowrap">
      {FILE_KINDS.map((kind) => {
        const has = present.includes(kind);
        return (
          <Tooltip
            key={kind}
            label={`No ${FILE_KIND_LABELS[kind]} file`}
            disabled={has}
          >
            <Group gap={2} wrap="nowrap">
              {has ? (
                <IconCheck size={14} color="var(--mantine-color-green-7)" />
              ) : (
                <IconMinus size={14} color="var(--mantine-color-gray-5)" />
              )}
              <Text size="xs" c={has ? 'bright' : 'dimmed'}>
                {FILE_KIND_LABELS[kind]}
              </Text>
            </Group>
          </Tooltip>
        );
      })}
    </Group>
  );
};
